export default {
  path: ":alias/trees",
  component: resolve => require(["@/views/trees"], resolve),
  children: [
    {
      path: "categories",
      component: resolve => require(["@/views/categories/list"], resolve)
    },
    {
      path: "list",
      component: resolve => require(["@/views/trees/list"], resolve)
    },
    {
      path: "list/form/:id?",
      component: resolve => require(["@/views/trees/form"], resolve)
    },
    {
      path: ":from/treeAdoptions",
      component: resolve => require(["@/views/tree-adoptions/list"], resolve)
    },
    {
      path: ":from/treeNursings",
      component: resolve => require(["@/views/tree-nursings/list"], resolve)
    },
    {
      path: ":from/treeWishes",
      component: resolve => require(["@/views/tree-wishes/list"], resolve)
    }
  ]
};
